import React, { useCallback } from 'react';
import { useBreakpoint } from '@sightworks/block';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import clsx from 'clsx';
import { FieldProps } from '../../registry';
import RatingBody from './body';

const RatingField = ({ dispatch, id, error, title, classes, value, content }: RatingBody) => {
	const callback = useCallback(event => {
		dispatch({ action: 'setField', data: { [id]: event.target.value } });
	}, [ dispatch, id ]);
	const breakpoint = useBreakpoint();
	const x: Partial<TextFieldProps> = {};

	if (error) {
		x.error = true;
		x.helperText = "Please fill out this field.";
	}
	const Item = breakpoint == 'xs' ? 'option' : MenuItem;
	
	return (
		<TextField select SelectProps={{ native: breakpoint == 'xs' }} variant='filled' label={title} className={clsx(classes.field, classes.rating)} value={value} onChange={callback} {...x}>
			{content.map(value => <Item key={value} value={value}>{value}</Item>)}
		</TextField>
	);
}

export default RatingField;
export const Style = {
	rating: {
		flex: 1
	}
};

